import type { ContactSetting } from '~/types/global.types'

import type { Page } from '~/composables/useApiFetch.composables'

const CONTACT_SETTINGS_KEY = 'contact-settings'

export function useContactSettings() {
    const nuxtApp = useNuxtApp()

    return useApiFetch<Page<ContactSetting>>('/v1/settings', {
        key: CONTACT_SETTINGS_KEY,
        dedupe: 'defer',
        getCachedData(key) {
            return nuxtApp.payload?.data?.[key]
        },
    })
}
